/** Liens du hub « Référents » (panel v1). */export type ReferentPanelLink = {
  referentFunction: string;
  path: string;
  allowAllReferents?: boolean;
  allowOnlyCm?: boolean;
  labelKey?: string;
};

export const REFERENT_PANEL_LINKS: ReferentPanelLink[] = [
  { referentFunction: 'Référent CM', path: '/panel/cm/referent' },
  { referentFunction: 'Référent Admin', path: '/panel/users/roles' },
  { referentFunction: 'Référent Modo', path: '/panel/system/security-logs' },
  { referentFunction: 'Référent Scénariste', path: '/panel/interventions/create' },
  { referentFunction: 'Référent GR', path: '/panel/interventions/manage' },
  {
    referentFunction: '',
    path: '/panel/roles/individual',
    allowOnlyCm: true,
    labelKey: 'sections.referent.items.manageIndividualRoles',
  },
];
